import type {
  EditorReadyFn,
  FlowEditorSDK,
  GetAppManifestFn,
} from '@wix/yoshi-flow-editor';

import componentJson from './components/Profile/.component.json';
import { customizeFieldsEventId, manageMemberPagesEventId } from './constants';
import {
  getMembersAreaContext,
  globalAppState,
  MembersAreaContext,
  refreshApp,
  registerGfppEventListeners,
} from './editor/services';

const editorReady: EditorReadyFn = async (editorSDK, _, __, flowAPI) => {
  globalAppState.setFlowAPI(flowAPI);
  registerGfppEventListeners(editorSDK);
};

const getAppManifest: GetAppManifestFn = async (
  { appManifestBuilder },
  editorSDK,
  _,
  flowAPI,
) => {
  if (!globalAppState.getFlowAPI()) {
    globalAppState.setFlowAPI(flowAPI);
  }

  const membersAreaContext = await getMembersAreaContext(editorSDK);
  const isMembersAreaV1Context = membersAreaContext === MembersAreaContext.V1;
  const isMembersAreaV2Context = membersAreaContext === MembersAreaContext.V2;
  const isMembersAreaV3Context = membersAreaContext === MembersAreaContext.V3;
  const helpIdV2 = 'f168bedd-2549-4a04-920b-b0b49bb4c7c1';
  const helpIdV3 = 'd35acbcf-fb4a-4b61-9727-50265753b07d';
  const mainAction2 = isMembersAreaV1Context
    ? {
        actionId: manageMemberPagesEventId,
        label: flowAPI.translations.t('app.gfpp.manage-member-pages'),
      }
    : {
        actionId: customizeFieldsEventId,
        label: flowAPI.translations.t('app.gfpp.customize-fields'),
      };

  return appManifestBuilder
    .configureWidget(componentJson.id, (builder) => {
      builder.behavior().set({ removable: false });

      builder.gfpp().set('widgetPlugins', { behavior: 'HIDE' });

      builder.gfpp('desktop').set('mainAction2', mainAction2);

      if (isMembersAreaV3Context || isMembersAreaV2Context) {
        builder.gfpp('desktop').set('help', {
          id: isMembersAreaV3Context ? helpIdV3 : helpIdV2,
        });
      }
    })
    .build();
};

const _exports = (editorSDK: FlowEditorSDK) => ({
  public: {
    refreshApp: () => refreshApp(editorSDK),
  },
});

export { editorReady, _exports as exports, getAppManifest };
